import React, { ReactNode, ComponentType } from "react";
import { Navigate, Outlet } from "react-router-dom";
import AdminLayout from "../layouts/AdminLayout";
import { storageService } from "utility/StorageService";

interface PrivateRouteProps {
  Layout: ComponentType<{ children: ReactNode }>;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({
  Layout = AdminLayout,
}) => {
  const token = storageService.getItem("accessToken");
  // const isLogin = true;
  if (token) {
    return (
      <>
        <Layout>
          <Outlet />
        </Layout>
      </>
    );
  } else {
    return <Navigate to="/login" />;
  }
};

export default PrivateRoute;
